import { Button } from '@mantine/core';
import { type FC, useState } from 'react';
import { useHostContext } from '@/context/HostContext.tsx';
import ConfirmationHeader from '@/pages/BusinessConfirmation/components/ConfirmationHeader';

type SearchAgainFormProps = {
	initialValue: string;
	onSearch: (query: string) => void;
};

const SearchAgainForm: FC<SearchAgainFormProps> = ({
	initialValue,
	onSearch
}) => {
	const [value, setValue] = useState(initialValue);
	const { localization } = useHostContext();

	return (
		<div
			className="flex min-h-[360px] flex-1 flex-col items-center justify-center py-4 sm:py-6"
			data-testid="business-confirmation-search-again"
		>
			<div className="w-full max-w-xl">
				<ConfirmationHeader
					title={localization.translate(
						'creator',
						'businessConfirmation.searchAgainForm.title'
					)}
				/>
				<textarea
					className="w-full resize-y rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-900 focus:outline-none"
					data-testid="business-confirmation-search-input"
					onChange={(e) => setValue(e.target.value)}
					rows={10}
					value={value}
				/>
				<div className="mt-4 flex justify-end">
					<Button
						color="dark"
						data-testid="business-confirmation-search-again-btn"
						disabled={!value.trim()}
						onClick={() => onSearch(value.trim())}
						radius="xl"
						size="md"
						variant="filled"
					>
						{localization.translate(
							'creator',
							'businessConfirmation.searchAgainForm.nextButton'
						)}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default SearchAgainForm;
